import { useMemo } from "react";
import { useIsMobile } from "./useIsMobile";

export function useDateFormats() {
  const isMobile = useIsMobile()
  return useMemo(() => ({
    shortFormat: isMobile ? 'll' : 'LL',
    longFormat: isMobile ? 'lll' : 'LLL'
  }), [isMobile])
}
